
<div id="topbar" class="d-none d-xl-block d-lg-block">
    <div class="container">
        <div class="row">
            
           
        <div class="col-md-6 d-none d-sm-block">
            <div class="social-icons social-icons-colored-hover">
                <!-- <ul>
                    <li class="social-facebook"><a href="#"><i class="fab fa-facebook-f"></i></a></li>
                    <li class="social-linkedin"><a href="#"><i class="fab fa-linkedin"></i></a></li>
                </ul> -->
            </div>
        </div>

        <div class="col-md-6 text-right" *ngIf="!loggato">
            <ul class="top-menu">
                <li><a routerLink="/accedi">ACCEDI</a></li>
                <li><a routerLink="/registrati">REGISTRATI</a></li>
            
                <li *ngIf="azienda == 'Pro.Dis'"><a routerLink="/azienda">Chi siamo</a></li>
                <li><a routerLink="/contatti">CONTATTI</a></li>
           
            </ul>
        </div>
        <div class="col-md-6 text-right" *ngIf="loggato">
            Benvenuto, <a routerLink="/storico-ordini">{{user.societa}}</a>
        </div>
        </div>
    </div>
</div>
<header id="header" class="">
    <div class="header-inner">    
        <div class="container">
            <div class="row">
                <div class="col-md-4">
                    <!--Navigation-->
            
            <div id="mainMenu" class="menu-animate" [ngStyle]="{'min-height':minHeight}">
                <div class="container">
                    <nav>
                        <ul>
                             
                            <li class="dropdown mega-menu-item"><a routerLink="/canvass" (click)="closeMenuMobile()">Canvass</a>
                                
                            </li>
                            <li class="dropdown mega-menu-item"><a routerLink="/volantino" (click)="closeMenuMobile()">Volantino</a>
                                
                            </li>
                            <li class="dropdown mega-menu-item"><a routerLink="/novita" (click)="closeMenuMobile()">Espositori</a>
                                
                            </li>
                            <li class="dropdown mega-menu-item d-sm-block d-md-block d-lg-none d-xl-none d-xxl-none " *ngIf="loggato"><a routerLink="/storico-ordini" (click)="closeMenuMobile()">Area Riservata</a>
                                
                            </li>
                           <!--  <li class="dropdown mega-menu-item"><a routerLink="/contatti" (click)="closeMenuMobile()">Contatti</a>
                                
                            </li>
                             -->
                            
                           
                        </ul>
                    </nav>
                </div>
            </div>
            <!--end: Navigation-->
                </div>

                <div class="col-md-4">
                     <!--Logo-->
                        <div id="logo">
                            <a routerLink="/">
                                <span class="logo-default"><img src="./assets/img/{{logoHeader}}" alt="Ingromarket Logo"></span>
                            </a>
                        </div>
                        <!--End: Logo-->
                </div>

                <div class="col-md-4">
                    <!--Header Extras-->
            <div class="header-extras">
                <ul>
                    <!-- li>
                        <a id="btn-search" href="#"> <i class="icon-search"></i></a>
                    </li -->
                    <li>
                        <div class="cart-menu">
                            <a routerLink="/cart"><i class="icon-shopping-cart"></i><span>{{itemCart}}</span></a>
                        </div>
                    </li>
                </ul>
            </div>
            <!--end: Header Extras-->
                    <div id="mainMenu" class="menu-animate" [ngStyle]="{'min-height':minHeight}">
                        <div class="container">
                            <nav style="float: right;">
                                <ul>
                                     
                                    
                                    
                                    <li class="dropdown mega-menu-item search-form-top">
                                        
                                        <form class="form-inline">
                                              <div class="form-group mx-0">
                                                <input type="text" class="form-control form-search" name="cerca" id="searchkey" placeholder="Ricerca prodotto" [(ngModel)]="paramSearch" (keydown.enter)="cerca()">
                                              </div>
                                              <button type="button" class="btn btn-primary btn-sm" (click)="cerca(); closeMenuMobile()" >Cerca</button>
                                            </form>
                                        
                                        
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                    <!--end: Navigation-->
                </div>
            </div>

           
            <!-- Search -- >
            <div id="search"><a id="btn-search-close" class="btn-search-close" aria-label="Close search form"><i class="icon-x"></i></a>
                <form class="search-form" action="search-results-page.html" method="get">
                    <input class="form-control" name="q" type="text" placeholder="Scrivi & Cerca..." />
                    <span class="text-muted">Inizia a scrivere & premi "Invio" oppure "ESC" per chiudere</span>
                </form>
            </div>
            <! -- end: search -->
            
            <!--Navigation Resposnive Trigger-->
            <div id="mainMenu-trigger">
                <a class="lines-button x" (click)="toggleNavbar()"><span class="lines"></span></a>
            </div>
            <!--end: Navigation Resposnive Trigger-->
            
        </div>
    </div>

    
    
</header>

<p-megaMenu [model]="gfg" id="megamenu"></p-megaMenu>
    